import React from "react";
import { Message,Icon } from 'semantic-ui-react';
import { connect } from "react-redux";
import {reactLocalStorage} from 'reactjs-localstorage';

class DownloadToast extends React.Component {
    componentWillMount()
    {
        
        this.setState({viewData:reactLocalStorage.get('viewDownloadResponse')})
    }
    constructor() {
        super();
    
        this.state = {
            viewData:'',
        };
    
      }
    
    render(){
        return(
            <div className="viewBox" style={{display:'block'}}>  
            <Message icon className='download_box_job'>
            <Icon name='circle notched' loading />
            <Message.Content>
              <Message.Header>Wait for downloading</Message.Header>
             {this.state.viewData}
            </Message.Content>
          </Message></div>  
        )
    }
}

const mapStateToProps = state => {
    return { ...state };
  };
  export default connect(mapStateToProps)(DownloadToast);